/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-08-27 19:14:53
 * @LastEditors: hongye
 * @LastEditTime: 2025-12-02 10:54:16
 * @Description: file content
 */
import { addressService } from '@/service/api'
import { defineStore } from 'pinia'

export const useCityStore = defineStore('city', {
  state: () => ({
    /**城市字典 */
    CITY: [] as any[],
    loading: false
  }),
  actions: {
    /**
     * 获取城市字典
     * @returns promise
     */
    getCityList() {
      return new Promise((resolve, reject) => {
        if (this.CITY.length) return resolve(this.CITY)
        this.loading = true
        addressService.queryAllSysArea().then((res) => {
          if (res.code === 1) {
            this.CITY = (res.data || []).map((item: any) => {
              if (item.childrenList && item.childrenList.length) {
                item.childrenList = item.childrenList.sort((a: any, b: any) => {
                  return a.nativeName.charAt(0).localeCompare(b.nativeName.charAt(0))
                })
              } else {
                delete item.childrenList
              }
              return item
            }).sort((a: any, b: any) => {
              // 先按dataType排序
              if (a.dataType !== undefined) {
                 const typeCompare = b.dataType - a.dataType;
                if (typeCompare !== 0) return typeCompare;
              }
              return a.nativeName.charAt(0).localeCompare(b.nativeName.charAt(0))
            })
            resolve(this.CITY)
          }
        }).finally(() => {
          this.loading = false
        })
      })
    }
  },
  persist: {
    storage: sessionStorage
  }
})
